import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-525b99c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchGroup" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_4 = {
  class: "mt-10",
  style: {"position":"relative"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_6 = { style: {"position":"absolute","right":"10px","top":"0","bottom":"0"} }
const _hoisted_7 = { class: "d-flex align-items-center" }

import { ref, Ref, reactive, onActivated, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import router from '@/router/index'
import { formatNumber, getNumber, exportHandle } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const {
  'POST/commission': fetchList,
  // 订单提成导出
  'POST/commission/export': exportApi,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_height
} = new tbMix(fetchList)
const tbData = computed(() => {
  return MI_tableData.value.reduce((arr: any[], row: any) => {
    // 一行订单固定拆分成五行
    return arr.concat([
      {...row, project: 'AM', commissionOwner: row.am, ratio: row.amRatio ? row.amRatio + '%': '', commissionAmount: row.amAmount},
      {...row, project: 'PM', commissionOwner: row.pm, ratio: row.pmRatio ? row.pmRatio + '%': '', commissionAmount: row.pmAmount},
      {...row, project: 'CM', commissionOwner: row.cm, ratio: row.cmRatio ? row.cmRatio + '%': '', commissionAmount: row.cmAmount},
      {...row, project: 'share', commissionOwner: row.share, ratio: row.shareRatio ? row.shareRatio + '%': '', commissionAmount: row.shareAmount},
      {...row, project: '销售补充', commissionOwner: row.owner, ratio: row.ownerRatio ? row.ownerRatio + '%': '', commissionAmount: row.ownerAmount},
    ])
  }, [])
})

const searchEle = ref()
const searchObj = reactive({
  am: '', cm: '', pm: '', share: '', orgId: '',
  orderNo: '', createdAt: [], deliverAt: [], closeAt: [], customerName: '',
})

let sumTotalCommission = ref<number>(0)
const searchHandle = (isReset = false) => {

  if(router.currentRoute.value.query?.ids){
    MI_params.orderNos = router.currentRoute.value.query.ids.split(',')
    router.push({path: '/comission', query: {}})
  }
  if(isReset){
    MI_params.orderNos = []
  }
  fetchData({
    ...searchObj,
    // ...params,
    createDate: {from: searchObj.createdAt?.[0], to: searchObj.createdAt?.[1]},
    deliverDate: {from: searchObj.deliverAt?.[0], to: searchObj.deliverAt?.[1]},
    closeDate: {from: searchObj.closeAt?.[0], to: searchObj.closeAt?.[1]},
  }).then((rep) => {
    sumTotalCommission.value = rep.sumTotalCommission
  })
}

const pageChange = (page: number) => {
  MI_pageChange(page).then((rep) =>{
    sumTotalCommission.value = rep.sumTotalCommission
  })
}

const sizeChange = (size: number) => {
  MI_sizeChange(size).then((rep) =>{
    sumTotalCommission.value = rep.sumTotalCommission
  })
}

// 导出
const exportSearch = () => {
  ElMessageBox.confirm('请确认是否导出?', '提示').then(() => {
    MI_identify.value = true
    return exportHandle(exportApi, MI_params)
  }).then(() => {
    ElMessage.success('导出成功')
  }).finally(() => {
    MI_identify.value = false
  })
}

// -----------------
const arraySpanMethod = ({ row, column, rowIndex, columnIndex }: any) => {
  if ([0, 5, 6, 6, 7, 8, 9].includes(columnIndex)) {
    if(rowIndex  % 5 === 0 ){
      return [5, 1]
    } else {
      return [0, 0]
    }
  }
}

expose({
  searchHandle
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "点此展开搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "searchEle",
              ref: searchEle,
              model: _unref(searchObj),
              "label-width": "auto",
              inline: "",
              class: "searchBg",
              disabled: _unref(MI_identify)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "订单号:",
                  prop: "orderNo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).orderNo,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).orderNo) = $event)),
                      placeholder: "请输入订单号",
                      clearable: "",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "创建时间:",
                  prop: "createdAt"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchObj).createdAt,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).createdAt) = $event)),
                      type: "daterange",
                      "value-format": "YYYY-MM-DD",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "交付时间:",
                  prop: "deliverAt"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchObj).deliverAt,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).deliverAt) = $event)),
                      type: "daterange",
                      "value-format": "YYYY-MM-DD",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "关闭时间:",
                  prop: "closeAt"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchObj).closeAt,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchObj).closeAt) = $event)),
                      type: "daterange",
                      "value-format": "YYYY-MM-DD",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户:",
                  prop: "customerName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).customerName,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchObj).customerName) = $event)),
                      placeholder: "请输入客户",
                      clearable: "",
                      maxlength: "200"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "团队:",
                  prop: "orgId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).orgId,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchObj).orgId) = $event)),
                      placeholder: "请选择团队",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysOrganizations, (org) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: org.name,
                            value: org.id,
                            key: org.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_el_form_item, {
                    label: "PM:",
                    prop: "pm"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(searchObj).pm,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchObj).pm) = $event)),
                        placeholder: "请选择PM",
                        clearable: "",
                        filterable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysUsers, (user) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: `${user.alias} (${user.realName})`,
                              value: user.alias
                            }, null, 8, ["label", "value"]))
                          }), 256))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "CM:",
                    prop: "cm"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(searchObj).cm,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(searchObj).cm) = $event)),
                        placeholder: "请选择CM",
                        clearable: "",
                        filterable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysUsers, (user) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: `${user.alias} (${user.realName})`,
                              value: user.alias
                            }, null, 8, ["label", "value"]))
                          }), 256))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "AM:",
                    prop: "am"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(searchObj).am,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(searchObj).am) = $event)),
                        placeholder: "请选择AM",
                        clearable: "",
                        filterable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysUsers, (user) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: `${user.alias} (${user.realName})`,
                              value: user.alias
                            }, null, 8, ["label", "value"]))
                          }), 256))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "SHARE:",
                    prop: "share"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(searchObj).share,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(searchObj).share) = $event)),
                        placeholder: "请选择share",
                        clearable: "",
                        filterable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysUsers, (user) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: `${user.alias} (${user.realName})`,
                              value: user.alias
                            }, null, 8, ["label", "value"]))
                          }), 256))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => {searchEle.value.resetFields(); _unref(MI_params).orderNos = []})
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (searchHandle(true)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_button, {
        onClick: exportSearch,
        type: "primary",
        disabled: _unref(MI_identify)
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createElementVNode("p", _hoisted_6, "本页提成金额合计: " + _toDisplayString(_unref(getNumber)(_unref(sumTotalCommission))), 1)
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      class: "mt-10",
      "span-method": arraySpanMethod,
      data: _unref(tbData),
      "max-height": _unref(MI_height) - 70 + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "订单ID",
          prop: "orderNo",
          width: "130",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "提成项目",
          prop: "project"
        }),
        _createVNode(_component_el_table_column, {
          label: "提成人",
          prop: "commissionOwner"
        }),
        _createVNode(_component_el_table_column, {
          label: "提成率",
          prop: "ratio"
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString(row.ratio), 1),
              (!!row.ownerRatioCompute && row.project === '销售补充')
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    effect: "dark",
                    content: row.ownerRatioCompute,
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_QuestionFilled)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["content"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "提成金额",
          prop: "commissionAmount",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "RMB回款金额",
          prop: "rmbAmount",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "成本",
          prop: "cost",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "毛利",
          prop: "grossProfit",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "计算提成日期",
          prop: "closeMonth"
        }),
        _createVNode(_component_el_table_column, {
          label: "总提成",
          prop: "totalCommission",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      class: "mt-10",
      disabled: _unref(MI_identify),
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[12] || (_cache[12] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[13] || (_cache[13] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      "page-sizes": [30, 50, 100, 500],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: pageChange,
      onSizeChange: sizeChange
    }, null, 8, ["disabled", "total", "currentPage", "page-size"])
  ]))
}
}

})